import React from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export const SUCCESS_NOTIF = 1;
export const ERROR_NOTIF = 2;

export const Notify = ({ type, message }) => {
  const isSuccess = type === SUCCESS_NOTIF;

  let style = {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    bottom: 100,
    left: '50%',
    transform: 'translateX(-50%)',
    minWidth: 250,
    maxWidth: 400,
    padding: '14px 24px',
    boxShadow: '0px 8px 16px rgba(20, 20, 43, 0.24)',
    borderRadius: 30,
    color: 'white',
    fontFamily: 'Arial',
    fontSize: 14,
    fontWeight: '600',
    zIndex: 9999
  };
  if (isSuccess) {
    style.backgroundColor = '#4CAF50';
  } else {
    style.backgroundColor = '#f44336';
  }
  return (
    <div style={style}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 8
        }}>
        {isSuccess ? <CheckCircleOutlineIcon style={{ fontSize: 20 }} /> : null}
        <span style={{ lineHeight: 1 }}>{message}</span>
      </div>
    </div>
  );
};
